import React from 'react';
import { Routes, Route } from 'react-router-dom';
import CandidateCompare from '../../pages/candidate-compare/candidate-compare';
import Home from '../../pages/home/home';
import { useAuth } from '../../providers/auth-provider';
import { LEADERSHIP_COACHING, LEADERSHIP_DEVELOPMENT, LEADERSHIP_MANAGER } from '../../pages/reports/leader-reports';
import ReportsContainer from '../../pages/reports/reports-container';
import {
  CANDIDATE_DEVELOPMENT,
  CANDIDATE_PROFILE,
  NEW_HIRE_COACHING,
  NEW_HIRE_DEVELOPMENT,
  NEW_HIRE_MANAGER,
} from '../../pages/reports/candidate-reports';
import ReportsMenuPage from '../../pages/reports/reports-menu-page';
import AssessmentParticipation from '../../pages/participation/assessment-participation';
import { launchEnabled } from '../../api/client';
import Launch from '../../pages/launch/launch';

function ClientRoutes() {
  const { isDevelop } = useAuth();

  return (
    <Routes>
      <Route path="/*" element={<Home />} />
      <Route path="/reports/:reference" element={<ReportsMenuPage />} />
      {isDevelop() ? (
        <>
          <Route path="participation">
            <Route path=":filterReference" element={<AssessmentParticipation />} />
            <Route path="" element={<AssessmentParticipation />} />
          </Route>
          <Route path="/leaders/compare" element={<CandidateCompare />} />
          <Route
            path="/report/leader/coaching/:reference"
            element={<ReportsContainer reportSelection={LEADERSHIP_COACHING} />}
          />
          <Route
            path="/report/leader/development/:reference"
            element={<ReportsContainer reportSelection={LEADERSHIP_DEVELOPMENT} />}
          />
          <Route
            path="/report/leader/manager/:reference"
            element={<ReportsContainer reportSelection={LEADERSHIP_MANAGER} />}
          />
          {launchEnabled(true) && <Route path="/launch" element={<Launch />} />}
        </>
      ) : (
        <>
          <Route path="/participation">
            <Route path=":filterReference" element={<AssessmentParticipation />} />
            <Route path="" element={<AssessmentParticipation />} />
          </Route>
          <Route path="/candidates/compare" element={<CandidateCompare />} />
          <Route
            path="/report/candidate/profile/:reference"
            element={<ReportsContainer reportSelection={CANDIDATE_PROFILE} />}
          />
          <Route
            path="/report/candidate/development/:reference"
            element={<ReportsContainer reportSelection={CANDIDATE_DEVELOPMENT} />}
          />
          <Route
            path="/report/new-hire/coaching/:reference"
            element={<ReportsContainer reportSelection={NEW_HIRE_COACHING} />}
          />
          <Route
            path="/report/new-hire/manager/:reference"
            element={<ReportsContainer reportSelection={NEW_HIRE_MANAGER} />}
          />
          <Route
            path="/report/new-hire/development/:reference"
            element={<ReportsContainer reportSelection={NEW_HIRE_DEVELOPMENT} />}
          />
          {launchEnabled(false) && <Route path="/launch" element={<Launch />} />}
        </>
      )}
    </Routes>
  );
}

export default ClientRoutes;
